<template>
    <div>
        <b-form @submit.prevent="search">
            <b-form-group
                label="Search"
                for="search"
            >
                <b-input-group>
                    <b-form-input ref="search-term" type="search" v-model="search_term" />
                    <b-input-group-append>
                        <b-btn type="submit" variant="outline-secondary" :disabled="searching">
                            <font-awesome-icon :icon="['fad', 'search']" />
                        </b-btn>
                    </b-input-group-append>
                    <b-input-group-append v-if="searched">
                        <b-btn variant="outline-danger" :disabled="searching" @click.prevent="clearSearch">
                            <font-awesome-icon :icon="['fad', 'backspace']" />
                        </b-btn>
                    </b-input-group-append>
                </b-input-group>
            </b-form-group>
        </b-form>

        <div v-if="searching" class="mb-3">
            <b-spinner label="Spinning"></b-spinner>
        </div>

        <div v-else>
            <b-list-group v-if="worksheets && worksheets.length" class="my-3">
                <b-list-group-item v-for="(worksheet, index) in worksheets" :key="index">
                    <div class="d-flex align-items-center">
                        <div class="d-flex align-items-center">
                            <span
                                class="collapse-icon mr-2"
                                :class="{'collapsed': !worksheet.visible}"
                                :aria-expanded="worksheet.visible ? 'true' : 'false'"
                                @click.prevent="toggleVisibility(worksheet)"
                            >
                                <span class="open">
                                    <font-awesome-icon :icon="['fas', 'caret-down']" fixed-width />
                                </span>
                                <span class="closed">
                                    <font-awesome-icon :icon="['fas', 'caret-right']" fixed-width />
                                </span>
                            </span>
                            <div class="mr-2">ID: {{worksheet.id}} </div>
                            <div v-if="worksheet.dam_id" class="mr-2"> Merlin ID: {{worksheet.dam_id}} </div>
                            <div v-if="worksheet.title"> Title: {{worksheet.title}} </div>
                            <div v-else class="text-muted"> no title</div>

                        </div>
                        <div class="ml-auto">
                            <div v-if="worksheetLinked(worksheet)">
                                <b-link href="#" class="text-warning" @click.prevent="unlinkWorksheet(worksheet)">
                                    <font-awesome-icon :icon="['fad', 'unlink']" />
                                </b-link>
                            </div>
                            <div v-else>
                                <b-link href="#" @click.prevent="linkWorksheet(worksheet)">
                                    <span v-if="article_worksheets">
                                        <font-awesome-icon :icon="['fad', 'link']" />
                                    </span>
                                    <span v-else>
                                        <font-awesome-icon :icon="['fad', 'plus-square']" />
                                    </span>
                                </b-link>
                            </div>
                        </div>
                    </div>
                    <b-collapse
                        v-model="worksheet.visible"
                        :class="worksheet.visible ? null : 'collapsed'"
                    >
                        <div class="mt-3">
                            <worksheet-contents :worksheet="worksheet" />
                        </div>
                    </b-collapse>
                </b-list-group-item>
            </b-list-group>

            <b-alert variant="danger" :show="searched && (!worksheets || worksheets && !worksheets.length)">
                0 results
            </b-alert>
        </div>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
import WorksheetContents from '@/components/worksheet/WorksheetContents'

export default {
    data: () => ({
        worksheets: [],

        search_term: '',

        searching: false,
        searched: false
    }),
    props: [
        'article_worksheets'
    ],
    components: {
        WorksheetContents
    },
    computed: {

    },
    methods: {
        async search() {
            if (this.search_term) {
                this.searched = false
                this.searching = true

                this.worksheets = []

                try {
                    const sanitizedSearch = encodeURIComponent(this.search_term)
                    const response = await this.axios.get(`/api/articles/search_worksheets/${sanitizedSearch}`)
                    if (response.data) {
                        this.worksheets = response.data
                    }

                    this.searched = true
                    this.searching = false
                } catch (e) {
                    this.searched = true
                    this.searching = false
                }
            }
        },
        linkWorksheet(worksheet) {
            this.$emit('link', worksheet)
        },
        unlinkWorksheet(worksheet) {
            this.$emit('unlink', worksheet)
        },
        worksheetLinked(worksheet) {
            let worksheetLinked = false

            if (
                this.article_worksheets &&
                _.find(this.article_worksheets, {id: worksheet.id})
            ) {
                worksheetLinked = true
            }

            return worksheetLinked
        },
        clearSearch() {
            this.search_term = ''
            this.searched = false

            this.worksheets = []

            if (this.$refs['search-term']) {
                this.$refs['search-term'].focus()
            }
        },
        toggleVisibility(worksheet) {
            if (!worksheet.visible) {
                this.$set(worksheet, 'visible', true)
            } else {
                this.$set(worksheet, 'visible', false)
            }
        }
    }
}
</script>
